import Vue from 'vue';
import VueYoutube from 'vue-youtube';
import Vuex, { mapGetters } from 'vuex';

Vue.component('YoutubeModal', {
  methods: {
    play: function() {
      this.$store.dispatch('overlay/show', { show: true, full: true, cb: this.close });
      this.isVideoVisible = true;
      this.player.loadVideoById(this.youtubeId);
		  if(this.autoPlay) {
			  this.player.playVideo();
		  }
    },
    closeByCross: function() {
	  	this.isVideoVisible = false;
      this.$store.dispatch('overlay/hide');
    },
    close: function() {
	  	this.isVideoVisible = false;
      this.player.stopVideo();
      this.$store.dispatch('youtube/stop');
    }
  },
  data: function() {
    return {
      playerRef: Math.random().toString(36).replace('0.', ''),
      isVideoVisible: false
    };
  },
  components: {
    VueYoutube
  },
  template: `
    <div class="video-modal" :class="{ 'video-modal--visible': isVideoVisible }">
      <button class="video-modal__btn-close" @click="closeByCross"><span class="icon-gunnebo-close"></span></button>
      <div class="video-modal__body">
        <youtube :ref="playerRef" :video-id="youtubeId" :player-vars="playerVars"></youtube>
      </div>
    </div>
  `,
  watch: {
    youtubeId: function() {
      if(this.youtubeId != '') {
        this.play();
      }
    }
  },
  computed: {
	  ...mapGetters({
	    youtubeId: 'youtube/currentYoutubeId',
	  	autoPlay: 'youtube/autoPlay',
	  }),
	  playerVars: function() {
		  return {
			   autoplay: this.autoPlay ? 1 : 0,
		   };
	  },
	  player: function() {
			return this.$refs[this.playerRef].player;
	  },
  },
})



// WEBPACK FOOTER //
// ./components/youtube/youtube-modal.js